/**
 * @desc 查询sku仓库包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuWarehousePackageRootResponseDto>;
export function request(skuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/getSkuWarehousePackage/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
